var exports = {
  "stars": "x936d19a0--eb4879--stars",
  "stars-size_s": "x936d19a0--eb4879--stars-size_s",
  "stars-size_m": "x936d19a0--eb4879--stars-size_m",
};

module.exports = exports;
